import React from 'react';

type Source = 'MBBS Lighthouse' | 'GMC' | 'Website' | string;

const sourceConfig: Record<string, { bg: string; text: string }> = {
  'MBBS Lighthouse': { bg: 'bg-primary/10', text: 'text-primary' },
  GMC: { bg: 'bg-purple-50', text: 'text-purple-700' },
  Website: { bg: 'bg-teal-50', text: 'text-teal-700' },
};

export default function SourceBadge({ source }: { source: Source }) {
  const config = sourceConfig[source] ?? { bg: 'bg-muted', text: 'text-muted-foreground' };
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${config.bg} ${config.text}`}
    >
      {source}
    </span>
  );
}